import React, { Component, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  Collapse,
  Navbar,
  NavbarBrand,
  Nav,
  NavLink,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl'
import { NavLink as RRNavLink } from 'react-router-dom';
import { MdClose, MdMenu } from 'react-icons/md'

import logo from './images/logo-atlas-gray.png'
import logoPt from './images/logo-atlas-cinza.png'

const MenuToggleMenuIcon = styled(MdMenu)`
  position: relative;
  top: 4px;
`

const MenuToggleClose = styled(MdClose)`
  position: relative;
  top: 4px;
  color: #fff;
`

const DivBg = styled.div`
  width:100%;
  @media only screen and (min-width: 992px) {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
`
const NavbarContainer = styled(Navbar)`
  &&& {
    height: 60px;
    padding: 0;
    z-index: 600;
    display: flex;
    justify-content: space-between;
    @media only screen and (min-width: 992px) {
      display: inline-flex;
    }    
  }
`
const NavLinkStyled = styled(NavLink)`
  color:#555959 !important;
  text-transform: uppercase;
  font-weight: bold;
  &:hover {
    text-decoration: underline !important;
  }
  &.active {
    color: #00a79d !important;
    border: 1px solid #00a79d;
    border-radius: 32px;
  }

  @media only screen and (max-width: 992px) {
    color:#fff !important;
    &.active {
      color: #fff !important;
      border: 2px solid #fff;
      padding: 10px!important;
      display: initial;
      text-decoration: none!important;
    }
 }
`

const NavStyled = styled(Nav)`
padding-left: 5rem!important;
  @media only screen and (max-width: 1058px) {
    padding-left: 1rem!important;
  }
  @media only screen and (max-width: 992px) {
    width: 100%;
  }
`
const NavItemStyled = styled(NavItem)`
  @media only screen and (max-width: 992px) {
    text-align:right;
    padding-right: 1.3rem !important;
    margin-bottom: 1rem;
  }
`

const DropdownToggleStyled = styled(DropdownToggle)`
  color:#555959;  
  font-weight: bold;
  &:hover {
    color:#555959;
    text-decoration: underline !important;
  }  

  @media only screen and (max-width: 992px) {
    color: #fff;
  }  
`

const UncontrolledDropdownStyled = styled(UncontrolledDropdown)`
  text-transform: uppercase;
  &.active {
    color: #00a79d !important;
    border: 1px solid #00a79d;
    border-radius: 32px;
  }
  @media only screen and (max-width: 992px) {
    color: #fff;
    text-align:right;
    padding-right: 1.3rem !important;
  }  
`

const ImageLogo = styled.img`
  max-width: 260px;
  @media only screen and (max-width: 991px) {
    max-width: 200px !important;
    margin-left:1.3rem;
  }
`
const Language = styled.span`
  cursor: pointer;
  font-weight: ${({ isSelected }) => isSelected ? 'bold' : 'normal'};
  margin-left: 1rem;
`

const MenuToggleButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  width: 72px;
  height: 60px;
  padding: 0;
  font-size: 42px;
  color: #00a79d;
  border: none;
  cursor: pointer;
  outline: none !important;
  background-color: transparent;
  border-radius: 32px 32px!important;
  z-index: 555;
  &.active {
    color: #fff;
  }

  @media only screen and (min-width: 992px) {
    display: none;
  }
`
const CollapsedStyled = styled.div`
  @media only screen and (max-width: 991px) {
    display: flex;
    position: absolute;
    right: 0;
    top: 0px;
    width: 320px;
    transform: translateX(${({ isOpen }) => isOpen ? 0 : 320}px);
    transition: ease .5s transform;
    z-index: 500;
    background: #00ab98;
    height: 100vh;
    padding-top: 5rem;
    border-radius: 32px 0 0 0;
  }
`

const Backdrop = styled.div`
  display: ${({ isOpen }) => isOpen ? 'block' : 'none'};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 499;
`

class Header extends Component {
  constructor(props) {
    super(props)

    this.onToggle = this.onToggle.bind(this)
    this.state = {
      isOpen: false
    }
  }

  onToggle() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  renderBackdrop(isOpen) {
    if(isOpen) {
      return (
        <Backdrop isOpen={isOpen} id="teste"/>
      );
    }

    return null;
  }

  render() {
    const { intl, language, onChangeLanguage } = this.props
    const { isOpen } = this.state
    let backDrop = this.renderBackdrop(isOpen);

    return (
      <DivBg>
        <NavbarContainer expand="lg">
          <NavbarBrand href="/"><ImageLogo src={language === 'pt-BR' ? logoPt : logo} /></NavbarBrand>
          <MenuToggleButton onClick={this.onToggle}>
            {isOpen ? <MenuToggleClose /> : <MenuToggleMenuIcon />}
          </MenuToggleButton>
          <CollapsedStyled isOpen={isOpen}>
            <NavStyled navbar>
              <NavItemStyled onClick={this.onToggle}>
                <NavLinkStyled exact to='/' tag={RRNavLink}>
                  <FormattedMessage id="menu.about" />
                </NavLinkStyled>
              </NavItemStyled>
              <NavItemStyled onClick={this.onToggle}>
                <NavLinkStyled exact to='/mapa' tag={RRNavLink}>
                  <FormattedMessage id="menu.map" />
                </NavLinkStyled>
              </NavItemStyled>
              <NavItemStyled onClick={this.onToggle}>
                <NavLinkStyled to='/pesquisa-agropecuaria' tag={RRNavLink}>
                  <FormattedMessage id="menu.survey" />
                </NavLinkStyled>
              </NavItemStyled>
              <NavItemStyled onClick={this.onToggle}>
                <NavLinkStyled to='/publicacoes' tag={RRNavLink}>
                  <FormattedMessage id="menu.publications" />
                </NavLinkStyled>
              </NavItemStyled>
              <NavItemStyled onClick={this.onToggle}>
                <NavLinkStyled to='/noticias' tag={RRNavLink}>
                  <FormattedMessage id="menu.news" />
                </NavLinkStyled>
              </NavItemStyled>
              <NavItemStyled onClick={this.onToggle}>
                <NavLinkStyled to='/contato' tag={RRNavLink}>
                  <FormattedMessage id="menu.contact" />
                </NavLinkStyled>
              </NavItemStyled>
              <NavItemStyled onClick={this.onToggle}>
                <NavLinkStyled href='/downloads'>
                  <FormattedMessage id="menu.db" />
                </NavLinkStyled>
              </NavItemStyled>
              <UncontrolledDropdownStyled nav inNavbar>
                <DropdownToggleStyled nav caret>
                  <FormattedMessage id="menu.language" />:
                </DropdownToggleStyled>
                <DropdownMenu right>
                  <DropdownItem>
                    <Language isSelected={language === 'pt-BR'} onClick={() => onChangeLanguage('pt-BR')}>PT</Language>
                  </DropdownItem>
                  <DropdownItem>
                    <Language isSelected={language === 'en-US'} onClick={() => onChangeLanguage('en-US')}>EN</Language>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdownStyled>
            </NavStyled>
          </CollapsedStyled>
        </NavbarContainer>
      </DivBg>
    );
  }
}
Header.propTypes = {
  onChangeLanguage: PropTypes.func.isRequired
}

export default injectIntl(Header)



// WEBPACK FOOTER //
// ./src/components/organisms/Header/Header.js